export const defaultChangePlansData = {
  basetime: 0,
  currencyCode: "",
  settlementScheduledPrice: 0,
  settlementScheduledTerm: "",
  settlementScheduledAt: 0,
  instantPayment: 0,
  upcomingTotal: 0,
  currentPlanName: "",
  afterPlanName: "",
  freePeriodAt: 0,
  isChangeSettlementScheduledAt: false,
  isInitialMonthInclusiveInvoice: false,
  isMonthlyFreeTrials: false,
  isFreePeriodEnded: false,
  newPlanCode: ""
};

export const props = {
  changePlansData: {
    default: () => defaultChangePlansData
  },
  lang: { default: () => ({}) },
  isChangeDevice: { default: false },
  isExToPro: { default: false },
  isProToEx: { default: false },
  isBillKonbiniPayment: { default: false },
  isSpecialCreditPayment: { default: false },
  urlHelpDifferenceAmount: { default: "" },
  urlHelpChangeDevice: { default: "" },
  urlHelpContinuedPatronage: { default: "" },
  urlHelpGalaxy: { default: "" },
  urlHelpChangeFreeTrial: { default: "" },
  urlDifferenceInGrade: { default: "" },
  urlGradeChange: { default: "" },
  contractDetailLink: { default: "" }
};
